import { Label } from 'components/atoms';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { PiCheck, PiEnvelopeSimple, PiHandCoinsBold, PiHourglassMedium, PiReceiptFill, PiSeal, PiSealCheck, PiSealWarning } from 'react-icons/pi';
import { CONNECTION_STATUS } from 'services/providers/types';
import { EMAIL_SEND } from 'services/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledProviderConnectionStatusProps {
  status: CONNECTION_STATUS;
}

interface ILabeledProviderConnectionStatusParams extends IColorProp {
  status: CONNECTION_STATUS;
  icon: ReactNode;
}

const labeledStatusParams: ILabeledProviderConnectionStatusParams[] = [
  {
    status: CONNECTION_STATUS.timeout,
    color: 'gray',
    icon: <PiSeal />,
  },
  {
    status: CONNECTION_STATUS.waiting,
    color: 'blue',
    icon: <PiHourglassMedium />,
  },
  {
    status: CONNECTION_STATUS.ok,
    color: 'green',
    icon: <PiSealCheck />,
  },
  {
    status: CONNECTION_STATUS.error,
    color: 'red',
    icon: <PiSealWarning />,
  },
];

const LabeledProviderConnectionStatus = ({ status }: ILabeledProviderConnectionStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledStatusParams.find(params => params.status === status) ??
    labeledStatusParams[0];

  return (
    <Label
      size='compact'
      color={labeledParams.color}
      title={t(`${labeledParams.status}`)}>
      {labeledParams.icon}{' '}
      {t(`enum.CONNECTION_STATUS.${CONNECTION_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledProviderConnectionStatus;
